import { __spreadArrays } from "tslib";
import { Children, isValidElement } from 'react';
export function concat(prefix) {
    var suffix = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        suffix[_i - 1] = arguments[_i];
    }
    return __spreadArrays([prefix], suffix).join('-');
}
export var isDev = process.env.NODE_ENV !== 'production';
/** 得到 ReactNode 中的文本 */
export function getText(node) {
    return Children.toArray(node).map(function (child) {
        if (typeof child === 'string') {
            return child;
        }
        if (typeof child === 'number') {
            return child + '';
        }
        if (isValidElement(child) && child.props) {
            return getText(child.props.children);
        }
        return '';
    }).join(' ');
}
/** 使用给定的值填充给定 ref，支持 ref object 或 callback ref */
export function fillRef(ref, value) {
    if (ref == null)
        return;
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    // ref.current 本来是 readonly 的
    ref.current = value;
}
export function assert(predict, message) {
    if (typeof predict === 'boolean') {
        if (!predict)
            throw Error(message);
        return;
    }
    if (!predict()) {
        throw Error(message);
    }
}
//# sourceMappingURL=index.js.map